/**
 * Do not edit this file manually!
 *
 * It is generated by scripts/dev/generate_fontawesome_manifest.rb
 * Use something like class="fa-solid fa-star" in a view/template/component and rerun the script
 */

import { library, dom, config } from "@fortawesome/fontawesome-svg-core";
import {
  faAdjust as faSolidAdjust,
  faAngleDoubleRight as faSolidAngleDoubleRight,
  faAngleLeft as faSolidAngleLeft,
  faAngleRight as faSolidAngleRight,
  faArchive as faSolidArchive,
  faArrowCircleUp as faSolidArrowCircleUp,
  faArrowDown as faSolidArrowDown,
  faArrowLeft as faSolidArrowLeft,
  faArrowRight as faSolidArrowRight,
  faArrows as faSolidArrows,
  faArrowsUpDownLeftRight as faSolidArrowsUpDownLeftRight,
  faBan as faSolidBan,
  faBars as faSolidBars,
  faCalendar as faSolidCalendar,
  faCaretDown as faSolidCaretDown,
  faCaretLeft as faSolidCaretLeft,
  faChartBar as faSolidChartBar,
  faCheck as faSolidCheck,
  faCheckSquare as faSolidCheckSquare,
  faChevronCircleDown as faSolidChevronCircleDown,
  faChevronRight as faSolidChevronRight,
  faCircle as faSolidCircle,
  faCircleInfo as faSolidCircleInfo,
  faCirclePlus as faSolidCirclePlus,
  faCircleQuestion as faSolidCircleQuestion,
  faClock as faSolidClock,
  faCloudDownload as faSolidCloudDownload,
  faCodeFork as faSolidCodeFork,
  faCogs as faSolidCogs,
  faEllipsisH as faSolidEllipsisH,
  faExclamation as faSolidExclamation,
  faExclamationTriangle as faSolidExclamationTriangle,
  faExternalLink as faSolidExternalLink,
  faEye as faSolidEye,
  faEyeSlash as faSolidEyeSlash,
  faFile as faSolidFile,
  faFlagCheckered as faSolidFlagCheckered,
  faFolder as faSolidFolder,
  faFolderOpen as faSolidFolderOpen,
  faGears as faSolidGears,
  faGlobe as faSolidGlobe,
  faGripDots as faSolidGripDots,
  faInfoCircle as faSolidInfoCircle,
  faLock as faSolidLock,
  faMessageXmark as faSolidMessageXmark,
  faPencil as faSolidPencil,
  faPipe as faSolidPipe,
  faPlay as faSolidPlay,
  faPlus as faSolidPlus,
  faRefresh as faSolidRefresh,
  faRotateLeft as faSolidRotateLeft,
  faRss as faSolidRss,
  faSave as faSolidSave,
  faSearch as faSolidSearch,
  faShare as faSolidShare,
  faShield as faSolidShield,
  faShieldHalved as faSolidShieldHalved,
  faSort as faSolidSort,
  faSortAsc as faSolidSortAsc,
  faSortDesc as faSolidSortDesc,
  faSortDown as faSolidSortDown,
  faSortUp as faSolidSortUp,
  faSpinner as faSolidSpinner,
  faSquare as faSolidSquare,
  faStar as faSolidStar,
  faTag as faSolidTag,
  faTags as faSolidTags,
  faTimes as faSolidTimes,
  faTimesCircle as faSolidTimesCircle,
  faTrash as faSolidTrash,
  faUnlock as faSolidUnlock,
  faUnlockAlt as faSolidUnlockAlt,
  faUser as faSolidUser,
  faUserCircle as faSolidUserCircle,
  faUserMinus as faSolidUserMinus,
  faUserPlus as faSolidUserPlus,
  faUserSecret as faSolidUserSecret,
  faUserTimes as faSolidUserTimes,
  faUserXmark as faSolidUserXmark,
  faUsers as faSolidUsers,
  faXmark as faSolidXmark,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faDailymotion as faBrandsDailymotion,
  faDeviantart as faBrandsDeviantart,
  faFacebook as faBrandsFacebook,
  faFlickr as faBrandsFlickr,
  faInstagram as faBrandsInstagram,
  faKickstarter as faBrandsKickstarter,
  faMicrosoft as faBrandsMicrosoft,
  faSlideshare as faBrandsSlideshare,
  faSoundcloud as faBrandsSoundcloud,
  faSpotify as faBrandsSpotify,
  faTwitter as faBrandsTwitter,
  faVimeo as faBrandsVimeo,
  faYoutube as faBrandsYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faAngleLeft as faRegularAngleLeft,
  faAngleRight as faRegularAngleRight,
  faArrowLeft as faRegularArrowLeft,
  faArrows as faRegularArrows,
  faArrowsRepeat as faRegularArrowsRepeat,
  faBars as faRegularBars,
  faBolt as faRegularBolt,
  faBoxArchive as faRegularBoxArchive,
  faBullhorn as faRegularBullhorn,
  faCalendarDay as faRegularCalendarDay,
  faChartColumn as faRegularChartColumn,
  faCheck as faRegularCheck,
  faCheckSquare as faRegularCheckSquare,
  faChevronDown as faRegularChevronDown,
  faChevronUp as faRegularChevronUp,
  faCircle as faRegularCircle,
  faCircleInfo as faRegularCircleInfo,
  faCirclePlus as faRegularCirclePlus,
  faCircleUser as faRegularCircleUser,
  faClipboardList as faRegularClipboardList,
  faClock as faRegularClock,
  faClone as faRegularClone,
  faCloudDownload as faRegularCloudDownload,
  faCloudUpload as faRegularCloudUpload,
  faComments as faRegularComments,
  faComputerClassic as faRegularComputerClassic,
  faEarthEurope as faRegularEarthEurope,
  faEdit as faRegularEdit,
  faEllipsis as faRegularEllipsis,
  faEllipsisH as faRegularEllipsisH,
  faEllipsisVertical as faRegularEllipsisVertical,
  faEnvelope as faRegularEnvelope,
  faEye as faRegularEye,
  faEyeSlash as faRegularEyeSlash,
  faFile as faRegularFile,
  faFileChartPie as faRegularFileChartPie,
  faFileExcel as faRegularFileExcel,
  faFilePdf as faRegularFilePdf,
  faFilePowerpoint as faRegularFilePowerpoint,
  faFileWord as faRegularFileWord,
  faFiles as faRegularFiles,
  faFilter as faRegularFilter,
  faFloppyDisk as faRegularFloppyDisk,
  faFolder as faRegularFolder,
  faFolderOpen as faRegularFolderOpen,
  faHandshake as faRegularHandshake,
  faInbox as faRegularInbox,
  faLanguage as faRegularLanguage,
  faList as faRegularList,
  faLocationDot as faRegularLocationDot,
  faMapLocationDot as faRegularMapLocationDot,
  faMobile as faRegularMobile,
  faNewspaper as faRegularNewspaper,
  faPaperclipVertical as faRegularPaperclipVertical,
  faPencil as faRegularPencil,
  faPencilSquare as faRegularPencilSquare,
  faPipe as faRegularPipe,
  faPlus as faRegularPlus,
  faPowerOff as faRegularPowerOff,
  faSearch as faRegularSearch,
  faShareSquare as faRegularShareSquare,
  faSidebar as faRegularSidebar,
  faSpinner as faRegularSpinner,
  faSquare as faRegularSquare,
  faStar as faRegularStar,
  faSuitcaseRolling as faRegularSuitcaseRolling,
  faTable as faRegularTable,
  faTags as faRegularTags,
  faTerminal as faRegularTerminal,
  faTrash as faRegularTrash,
  faTrashCan as faRegularTrashCan,
  faTriangleExclamation as faRegularTriangleExclamation,
  faUpload as faRegularUpload,
  faUser as faRegularUser,
  faUserCircle as faRegularUserCircle,
  faUserPlus as faRegularUserPlus,
  faUserXmark as faRegularUserXmark,
  faUsers as faRegularUsers,
  faVirus as faRegularVirus,
  faXmark as faRegularXmark,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faCloudArrowDown as faLightCloudArrowDown,
  faEnvelope as faLightEnvelope,
  faFile as faLightFile,
  faFileAudio as faLightFileAudio,
  faFileCode as faLightFileCode,
  faFileCsv as faLightFileCsv,
  faFileExcel as faLightFileExcel,
  faFileImage as faLightFileImage,
  faFileLines as faLightFileLines,
  faFilePdf as faLightFilePdf,
  faFilePowerpoint as faLightFilePowerpoint,
  faFileVideo as faLightFileVideo,
  faFileWord as faLightFileWord,
  faFileZipper as faLightFileZipper,
  faImage as faLightImage,
  faMobileScreenButton as faLightMobileScreenButton,
} from "@fortawesome/pro-light-svg-icons";
import {
  faChartSimple as faDuotoneChartSimple,
  faMedal as faDuotoneMedal,
  faUsers as faDuotoneUsers,
} from "@fortawesome/pro-duotone-svg-icons";

config.autoReplaceSvg = "nest";

library.add(
  faBrandsDailymotion,
  faBrandsDeviantart,
  faBrandsFacebook,
  faBrandsFlickr,
  faBrandsInstagram,
  faBrandsKickstarter,
  faBrandsMicrosoft,
  faBrandsSlideshare,
  faBrandsSoundcloud,
  faBrandsSpotify,
  faBrandsTwitter,
  faBrandsVimeo,
  faBrandsYoutube,
  faDuotoneChartSimple,
  faDuotoneMedal,
  faDuotoneUsers,
  faLightCloudArrowDown,
  faLightEnvelope,
  faLightFile,
  faLightFileAudio,
  faLightFileCode,
  faLightFileCsv,
  faLightFileExcel,
  faLightFileImage,
  faLightFileLines,
  faLightFilePdf,
  faLightFilePowerpoint,
  faLightFileVideo,
  faLightFileWord,
  faLightFileZipper,
  faLightImage,
  faLightMobileScreenButton,
  faRegularAngleLeft,
  faRegularAngleRight,
  faRegularArrowLeft,
  faRegularArrows,
  faRegularArrowsRepeat,
  faRegularBars,
  faRegularBolt,
  faRegularBoxArchive,
  faRegularBullhorn,
  faRegularCalendarDay,
  faRegularChartColumn,
  faRegularCheck,
  faRegularCheckSquare,
  faRegularChevronDown,
  faRegularChevronUp,
  faRegularCircle,
  faRegularCircleInfo,
  faRegularCirclePlus,
  faRegularCircleUser,
  faRegularClipboardList,
  faRegularClock,
  faRegularClone,
  faRegularCloudDownload,
  faRegularCloudUpload,
  faRegularComments,
  faRegularComputerClassic,
  faRegularEarthEurope,
  faRegularEdit,
  faRegularEllipsis,
  faRegularEllipsisH,
  faRegularEllipsisVertical,
  faRegularEnvelope,
  faRegularEye,
  faRegularEyeSlash,
  faRegularFile,
  faRegularFileChartPie,
  faRegularFileExcel,
  faRegularFilePdf,
  faRegularFilePowerpoint,
  faRegularFileWord,
  faRegularFiles,
  faRegularFilter,
  faRegularFloppyDisk,
  faRegularFolder,
  faRegularFolderOpen,
  faRegularHandshake,
  faRegularInbox,
  faRegularLanguage,
  faRegularList,
  faRegularLocationDot,
  faRegularMapLocationDot,
  faRegularMobile,
  faRegularNewspaper,
  faRegularPaperclipVertical,
  faRegularPencil,
  faRegularPencilSquare,
  faRegularPipe,
  faRegularPlus,
  faRegularPowerOff,
  faRegularSearch,
  faRegularShareSquare,
  faRegularSidebar,
  faRegularSpinner,
  faRegularSquare,
  faRegularStar,
  faRegularSuitcaseRolling,
  faRegularTable,
  faRegularTags,
  faRegularTerminal,
  faRegularTrash,
  faRegularTrashCan,
  faRegularTriangleExclamation,
  faRegularUpload,
  faRegularUser,
  faRegularUserCircle,
  faRegularUserPlus,
  faRegularUserXmark,
  faRegularUsers,
  faRegularVirus,
  faRegularXmark,
  faSolidAdjust,
  faSolidAngleDoubleRight,
  faSolidAngleLeft,
  faSolidAngleRight,
  faSolidArchive,
  faSolidArrowCircleUp,
  faSolidArrowDown,
  faSolidArrowLeft,
  faSolidArrowRight,
  faSolidArrows,
  faSolidArrowsUpDownLeftRight,
  faSolidBan,
  faSolidBars,
  faSolidCalendar,
  faSolidCaretDown,
  faSolidCaretLeft,
  faSolidChartBar,
  faSolidCheck,
  faSolidCheckSquare,
  faSolidChevronCircleDown,
  faSolidChevronRight,
  faSolidCircle,
  faSolidCircleInfo,
  faSolidCirclePlus,
  faSolidCircleQuestion,
  faSolidClock,
  faSolidCloudDownload,
  faSolidCodeFork,
  faSolidCogs,
  faSolidEllipsisH,
  faSolidExclamation,
  faSolidExclamationTriangle,
  faSolidExternalLink,
  faSolidEye,
  faSolidEyeSlash,
  faSolidFile,
  faSolidFlagCheckered,
  faSolidFolder,
  faSolidFolderOpen,
  faSolidGears,
  faSolidGlobe,
  faSolidGripDots,
  faSolidInfoCircle,
  faSolidLock,
  faSolidMessageXmark,
  faSolidPencil,
  faSolidPipe,
  faSolidPlay,
  faSolidPlus,
  faSolidRefresh,
  faSolidRotateLeft,
  faSolidRss,
  faSolidSave,
  faSolidSearch,
  faSolidShare,
  faSolidShield,
  faSolidShieldHalved,
  faSolidSort,
  faSolidSortAsc,
  faSolidSortDesc,
  faSolidSortDown,
  faSolidSortUp,
  faSolidSpinner,
  faSolidSquare,
  faSolidStar,
  faSolidTag,
  faSolidTags,
  faSolidTimes,
  faSolidTimesCircle,
  faSolidTrash,
  faSolidUnlock,
  faSolidUnlockAlt,
  faSolidUser,
  faSolidUserCircle,
  faSolidUserMinus,
  faSolidUserPlus,
  faSolidUserSecret,
  faSolidUserTimes,
  faSolidUserXmark,
  faSolidUsers,
  faSolidXmark,
);

dom.watch();
